import React from "react"

import Radio from "./RadioResponse"
import Checkbox from "./CheckboxResponse"
import AgeResponse from "../../identifiers/components/AgeResponse"
import TextResponse from "./TextResponse"
import EmailPhoneResponse from "./EmailPhoneResponse"
import Duration from "./DurationResponse"
import EmployerResponse from "./EmployerResponse"
import SpecialistResponse from "./SpecialistResponse"
import DiagnosisSearch from "./DiagnosisSearch"

const ResponseSwitch = ({
  chatItems,
  activeIndex,
  hide,
  zipcode,
  showIntegrationChat,
  isClient,
  editing,
  ...props
}) => {
  let activeItem = { ...chatItems[activeIndex] }

  if (!activeItem || (showIntegrationChat && !isClient) || hide) return <div />

  switch (activeItem.inputType) {
    case "radio":
      return <Radio item={activeItem} {...props} />

    case "checkbox":
      return <Checkbox item={activeItem} {...props} editing={editing} />

    case "duration":
      return <Duration item={activeItem} />

    case "age":
      return <AgeResponse item={activeItem} />

    case "text":
      return <TextResponse {...props} item={activeItem} />

    case "email":
      return <EmailPhoneResponse {...props} />

    case "employer":
      return <EmployerResponse {...props} item={activeItem} />

    case "specialist":
      return <SpecialistResponse {...props} item={activeItem} />

    case "diagnosis":
      return <DiagnosisSearch {...props} item={activeItem} />

    default:
      return <div />
  }
}

export { ResponseSwitch as default }



// WEBPACK FOOTER //
// ./assets/interview/components/ResponseSwitch.js